import {
 RecordsRow
} from './RecordsRow';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow as UITableRow,
} from 'shared/components/ui/table';

// Define types for the columns, rows, and props
import {
 Column,Row
} from './types/builderRecords.types';

interface RecordsContentProps {
  columns: Column[];
  displayedRows?: Row[];
  hiddenColumns: string[];
  selectedRows: string[];
  editingCell: { rowId: string; colId: string } | null;
  onCellClick: (rowId: string, columnName: string) => void;
  onCellChange: (rowId: string, columnName: string, value: any) => void;
  onCellBlur: (rowId: string, colId: string, value: any) => void;
  onDeleteRow: (rowId: string) => void;
  onSelectRow: (rowId: string) => void;
  updatedRows: Row[];
  createdRows?: Row[];
  isAddingNewRecord: boolean;
  tableId?: string | null;
  hiddenFields?: string[];
}

export function RecordsContent({
  columns,
  displayedRows = [], // Default to empty array if not passed
  hiddenColumns,
  selectedRows,
  // editingCell,
  // onCellClick,
  onCellChange,
  onCellBlur,
  onDeleteRow,
  onSelectRow,
  updatedRows,
  createdRows = [], // Default to empty array if not passed
  isAddingNewRecord,
  tableId = null,
  hiddenFields = [
    'password',
    'createdBy',
    'createdOn',
    'modifiedBy',
    'modifiedOn',
    'recordId',
  ],
}: RecordsContentProps) {
  // Ensure the newly added row is placed at the top
  const rowsWithNewRecordFirst = isAddingNewRecord
    ? [...createdRows, ...displayedRows.filter((row) => !row.isDraft)] // Add all created rows
    : displayedRows;

  return (
      <div className="h-0 flex-grow border-t">
          <div className="h-full w-full overflow-auto">
              <Table className="w-full relative">
                  <TableHeader className="sticky top-0 bg-background z-10">
                      <UITableRow>
                          <TableHead className="w-[50px] p-6"></TableHead>
                          {columns
                .filter(
                  (column) =>
                    !hiddenColumns.includes(column.columnName) &&
                    !hiddenFields.includes(column.columnName)
                )
                .map((column) => (
                    <TableHead
                    key={column.columnName}
                    className="whitespace-nowrap"
                  >
                        <div className="flex items-center gap-1 px-4 py-3 font-medium">
                            {column.columnName}
                        </div>
                    </TableHead>
                ))}
                          <TableHead className="w-[100px]">Actions</TableHead>
                      </UITableRow>
                  </TableHeader>
                  <TableBody>
                      {rowsWithNewRecordFirst.length === 0 ? (
                          <UITableRow>
                              <TableCell
                  colSpan={columns.length + 2 - hiddenColumns.length}
                  className="h-24 text-center text-muted-foreground"
                >
                                  No records found.
                              </TableCell>
                          </UITableRow>
            ) : (
              rowsWithNewRecordFirst.map((row) => {
                return row.isGroupHeader ? (
                    <UITableRow key={row.id}>
                        <TableCell
                      colSpan={columns.length + 2 - hiddenColumns.length}
                      className="font-medium bg-muted/50 py-2"
                    >
                            {row.groupValue}
                        </TableCell>
                    </UITableRow>
                ) : (
                    <RecordsRow
                    key={row.id}
                    row={row}
                    columns={columns}
                    hiddenColumns={hiddenColumns}
                    isSelected={selectedRows.includes(row.id)}
                    // isEditing={!!editingCell}
                    // editingCell={editingCell}
                    // onCellClick={onCellClick}
                    onCellChange={onCellChange}
                    onCellBlur={onCellBlur}
                    onDeleteRow={onDeleteRow}
                    onSelectRow={() => onSelectRow(row.id)}
                    updatedRows={updatedRows}
                    isAddingNewRecord={isAddingNewRecord}
                    tableId={tableId}
                    hiddenFields={hiddenFields}
                  />
                );
              })
            )}
                  </TableBody>
              </Table>
          </div>
      </div>
  );
}
